import {useEffect, useMemo, useState} from "react";

export const useMediaQuery = (query) => {
    const mediaMatch = useMemo(() => window.matchMedia(query), [query]);
    const [matches, setMatches] = useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        // modern API
        if (mediaMatch.addEventListener) {
            mediaMatch.addEventListener('change', handler);
            return () => mediaMatch.removeEventListener('change', handler);
        }
        // legacy fallback
        mediaMatch.addListener(handler);
        return () => mediaMatch.removeListener(handler);
    }, [mediaMatch]);

    return matches;
};
